import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';
import VimeoPlayer from 'react-player/vimeo';


export const VideoWrapper = styled.div`
  position: relative;
`;

export const Poster = styled(GatsbyImage)``;

export const StyledVimeoPlayer = styled(VimeoPlayer)`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
`;
